import React, { createContext, useContext, useState, ReactNode } from "react";

type GameModeType = "Control" | "Edit" | "Debug" | "Run";

interface GameContextType {
  gameMode: GameModeType;
  setGameMode: (mode: GameModeType) => void;
  message: string;
  setMessage: (message: string) => void;
  currentAction: string | null;
  triggerAction: (action: string) => void;
  isHelpPanelOpen: boolean;
  setHelpPanelOpen: (isOpen: boolean) => void;
  blockTransButton: boolean;
  setBlockTransButton: (isOpen: boolean) => void;
  blockNextButton:boolean;
  setBlockNextButton: (isOpen: boolean) => void;
}

const GameContext = createContext<GameContextType | undefined>(undefined);

export const GameProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [gameMode, setGameMode] = useState<GameModeType>("Edit");
  const [message, setMessage] = useState<string>("Получи 1 литр в любой колбе");
  const [currentAction, setCurrentAction] = useState<string | null>(null);
  const [isHelpPanelOpen, setHelpPanelOpen] = useState<boolean>(false);
  const [blockTransButton, setBlockTransButton] = useState<boolean>(false);
  const [blockNextButton, setBlockNextButton] = useState<boolean>(false);

  const triggerAction = (action: string) => {
    setCurrentAction(action);
    setTimeout(() => setCurrentAction(null), 100);
  };

  return (
    <GameContext.Provider
      value={{
        gameMode,
        setGameMode,
        message,
        setMessage,
        currentAction,
        triggerAction,
        isHelpPanelOpen,
        setHelpPanelOpen,
        blockTransButton,
        setBlockTransButton,
        blockNextButton,
        setBlockNextButton
      }}
    >
      {children}
    </GameContext.Provider>
  );
};

export const useGame = () => {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error("useGame must be used within a GameProvider");
  }
  return context;
};
